import React from "react";
import Head from "next/head";
interface IHeadTag {
    title: string;
}
export const HeadTag = ({ title }: IHeadTag) => {
    return (
        <Head>
            <link rel="preconnect" href="//analytics.swiggy.com" crossOrigin="anonymous" />
            <link rel="dns-prefetch" href="//analytics.swiggy.com" />
            <link rel="preconnect" href={process.env.NEXT_PUBLIC_CDN_URL} crossOrigin="anonymous" />
            <link rel="dns-prefetch" href={process.env.NEXT_PUBLIC_CDN_URL} />
            <title>{title}</title>
            <meta name="description" content="Swiggy Money" />
            <meta
                name="viewport"
                content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"
            />
            <link rel="icon" href="data:;base64,iVBORw0KGgo=" />
        </Head>
    );
};
